import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=4fffcdf8&"
import script from "./list-item.vue?vue&type=script&lang=ts&"
export * from "./list-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fffcdf8')) {
      api.createRecord('4fffcdf8', component.options)
    } else {
      api.reload('4fffcdf8', component.options)
    }
    module.hot.accept("./list-item.vue?vue&type=template&id=4fffcdf8&", function () {
      api.rerender('4fffcdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/list/list-item.vue"
export default component.exports